import { DatePicker } from 'primeng/datepicker';

/**
 * Figma date fields (all components):
 * - Icon inside the single input box (iconDisplay = input)
 * - Calendar opens only on calendar-icon click
 * - Does not open on input focus/click
 * - Input stays editable so the date can still be typed/changed
 */
export function configureFigmaDatePickerBehavior(): void {
  const proto = DatePicker.prototype as DatePicker & {
    onInit: (...args: unknown[]) => void;
    onInputFocus: (event: Event) => void;
    onInputClick: () => void;
    focus: boolean;
    onFocus: { emit: (event: Event) => void };
    showIcon: boolean | undefined;
    iconDisplay: 'input' | 'button';
    showOnFocus: boolean;
  };

  const originalOnInit = proto.onInit;
  proto.onInit = function (this: DatePicker & typeof proto, ...args: unknown[]) {
    this.showIcon = true;
    this.iconDisplay = 'input';
    this.showOnFocus = false;
    return originalOnInit.apply(this, args);
  };

  proto.onInputFocus = function (this: DatePicker & typeof proto, event: Event) {
    this.focus = true;
    this.onFocus.emit(event);
  };

  proto.onInputClick = function () {
    // no-op: do not open overlay from the input itself
  };
}
